import { RemarkDetail } from '../course/define';
import { ROLES } from '../team/define';
import { UnitContentType, Video } from '../unitResource/define';
import { TRUE_AND_FALSE } from '../base/define';
import { CourseSeries } from '../courseSeries/define';

export const DEFAULT_FACE_URL = 'https://pandapub.nosdn.127.net/pr__mfu6nodonhh0kvdbpi8og%3D%3D_2_1649929266_0.png';

export enum LOGIN_FROM {
  ADMIN = 'admin',
  WEB = 'web',
  WEBVIEW = 'WebView',
}

export enum userPowerType {
  SuperAdmin,
  Common,
}

export enum LoginType {
  Phone = 0,
  Email = 1,
  QQ = 4,
  Wechat = 6,
  AppleId = 85,
}
type TypeMap = {
  [key: number]: string;
}
type TypeMapString = {
  [key: string]: string;
}
export const LoginTypeMap: TypeMap = {
  [LoginType.Phone]: '手机',
  [LoginType.Email]: '邮箱',
  [LoginType.QQ]: 'QQ',
  [LoginType.Wechat]: '微信',
  [LoginType.AppleId]: 'AppleID',
};
export interface User {
  uid: number;
  mid: number;
  name: string;
  phone: number;
  loginType: LoginType;
  loginAccount: number;
  orderCount: number;
  courseCount: number;
  contactCount: number;
  sex: number;
  birthday: number;
  registerFrom: UserDeviceType;
  studentTag: StudentTagType;
  remark: RemarkDetail;
  channel: string;
  dbCreateTime: number;
  vipExpireTime: number;
  lastActiveTime: number;
  lastAppActiveTime: number;
  totalAppActiveDays: number;
  totalVipDays: number;
  totalOrderAmount: number;
  totalVipOrderAmount: number;
  totalNonVipAmount: number;
  wechatBindStatus?: number;
  firstEnterAppTime?: number;
}

export enum UserKeywordType {
  Phone = 1,
  Name = 2,
  UID = 3,
}

export enum UserDeviceType {
  Other = -1,
  IOS = 0,
  Web = 2,
  Android = 3,
  LEDU = 4,
  YOUDAO_PAD,
}

export const UserDeviceTypeMap: TypeMap = {
  [UserDeviceType.Other]: '其他',
  [UserDeviceType.IOS]: 'iOS',
  [UserDeviceType.Web]: 'Web',
  [UserDeviceType.Android]: '安卓',
  [UserDeviceType.LEDU]: '乐读Api',
  [UserDeviceType.YOUDAO_PAD]: '有道平板',
};

export enum AppStoreType {
  网易 = 'netease',
  华为 = 'huawei',
  小米 = 'xiaomi',
  oppo = 'oppo',
  vivo = 'vivo',
  魅族 = 'meizu',
  应用宝 = 'tencent',
  奇虎360 = '360',
  京东方 = 'jingdongfang',
  天猫精灵 = 'tmallbot',
  AppStore = 'AppStore',
  小度 = 'xiaodu',
  步步高 = 'bbk',
  有道平板 = 'YOUDAO_PAD',
}

export const AppStoreTypeMap: TypeMapString = {
  [AppStoreType.网易]: '网易',
  [AppStoreType.华为]: '华为',
  [AppStoreType.小米]: '小米',
  [AppStoreType.oppo]: 'oppo',
  [AppStoreType.vivo]: 'vivo',
  [AppStoreType.魅族]: '魅族',
  [AppStoreType.应用宝]: '应用宝',
  [AppStoreType.奇虎360]: '奇虎360',
  [AppStoreType.京东方]: '京东方',
  [AppStoreType.天猫精灵]: '天猫精灵',
  [AppStoreType.AppStore]: 'App Store',
  [AppStoreType.小度]: '小度',
  [AppStoreType.步步高]: '步步高',
  [AppStoreType.有道平板]: '有道平板',
};

export enum StudentTagType {
  Unpaid = 0,
  Experience,
  Formal,
}

export const StudentTagTypeMap: TypeMap = {
  [StudentTagType.Unpaid]: '未付费', // '未付费学员',
  [StudentTagType.Experience]: '付费<100元', // '体验课学员',
  [StudentTagType.Formal]: '付费≥100元', // '正式课学员',
};

export enum StudentMemberType {
  NotVip,
  Vip,
  OverdueVip,
}
export interface UserCourse {
  courseId: number;
  courseName: string;
  consultantName: string;
  consultantId: number;
  joinTime: number;
  orderCount: number;
  courseSeriesName?: string;
}
export interface YouDaoUser {
  yduserid: string;
  from: string;
  phone: number;
  userid: string;
}

export interface PandaUserInfo {
  id: number;
  uid: number;
  mid: number; // memberId
  birthday?: number;
  email?: string;
  headImgUrl?: string;
  nickName?: string;
  isAgree?: number;
  phoneNumber?: string;
  realName?: string;
  sex?: number;
  wxAccount?: string;
  isVip?: number; // 0非会员 1会员 2 过期会员
  vipExpireTime?: number; // 会员过期时间
}

export interface PandaUserAccount {
  id: number; // panda uid
  ydUserId?: string;
  ydCompatibleId?: string;
  loginAccount: string;
  loginType?: LoginType; // 帐号类型，0表示手机号
  registerFrom?: number;
  isNew?: number; // 是否新登录用户： 0不是， 1首次登录
}

export interface SteamTeamInfo {
  uid: number;
  roles: ROLES[];
  courseSeriesList?: CourseSeries[];
  assignFlag: boolean;
  assignPhone?: string;
}

export interface PanderPowerInfo {
  id: number;
  uid?: number;
  nickName?: string;
  powerType: userPowerType;
}

export interface PandaUserLoginInfo {
  code?: number; // 当接口出错时
  userInfo: PandaUserInfo;
  userAccount: PandaUserAccount;
  powerInfo?: PanderPowerInfo;
  teamInfo?: SteamTeamInfo;
  isAgree?: boolean; // 是否同意用户协议
  token: string; // 32位token
  isBindWeChat?: boolean; // 是否绑定微信
}

export interface PandaUserLoginRequest {
  from?: LOGIN_FROM;
  inviteCode?: string;
}

export interface LoginRequest {
  requestType?: LOGIN_FROM;
}

export interface Address {
  id?: number;
  addressee: string;
  phoneNumber: string;
  province: string;
  city: string;
  region: string;
  address: string;
  deliveryCode: string;
  orderId?: number;
}

export interface Integral {
  count: number;
}

export interface UserDetailRequest {
  uid: number;
}

export interface UserOrderRequest {
  courseId: number;
  uid?: number;
  keyword?: string;
}

export enum SEX {
  UNKNOWN,
  MALE,
  FEMALE,
}

export interface UserDetail {
  phoneNumber: number;
  realName: string;
  mid: number;
}

export interface UserInfo {
  userInfo: PandaUserInfo;
  userAccount: PandaUserAccount;
  teamInfo?: SteamTeamInfo;
  isBindWeChat?: boolean;
}

export interface TeamInfo {
  gmtCreate: number;
  gmtModified: number;
  id: number;
  isDeleted: number;
  isDisable: number;
  nickName: string;
  phone: string;
  realName: string;
  remark: string;
  role: number;
  uid: number;
  wechatAccount: string;
  wechatQrCode: string;
}

export interface SmsRequest{
  mobile: string;
  type: number; // 5.订单确认  8.送课活动申请 18.免费学返现确认
}

export enum MEMBER_SOURCE_TYPE {
  ORDER, // 订单购买
  CODE, // 兑换码兑换
  ADMIN, // 后台操作
  MEMBER_RECHARGE, // 会员充值
  ACTIVITY, // 活动
  ORDER_IMPORT, // 订单导入
  ACTIVITY_FREE_MEMBER, // 新学期送课
}
export interface Member {
  id: number;
  uid: number;
  day: number;
  sourceType: MEMBER_SOURCE_TYPE;
  sourceValue: number;
  sourceName: string;
  remark: string;
  gmtModified: number; // 订单支付成功时间/后台操作成功时间
  opUserName?: string; // 操作人真实姓名
  redeemId?: number; // 兑换码ID
}

export interface UpdateMemberRequest {
  uid: number;
  day: number | null;
  remark?: string;
  aceCourseFlag: number;
}

export interface UserLearnReportTotalStatistic {
  studyDays: number;
  studyCourseCount: number;
}

export interface UserLearnReportDayList {
  day: number;
  studyTime: number;
}

export interface UserLearnReportDailyUnit {
  startTime: number;
  endTime: number;
  courseId: number;
  courseName: string;
  chapterId: number;
  chapterName: string;
  unitId: number;
  unitName: string;
  learnResult: number;
  contentType: UnitContentType;
  questionErrorCount: number;
  percent: number; // 直播回放百分比
  studyTime: number; // 直播关卡时长
  isFinish: TRUE_AND_FALSE;
  templateUnitId?: number; // 作业-模板课时id
  folderId?: number; // 学习资料-文件夹id
  uploadTime?: number; // 作品课时-上传时间
  projectId?: number;
  contentId?: string; // 作品 图片、视频链接
  videoBean?: Video;
}

export interface AccountCancellationRequest {
  confirmPhone: string;
  confirmMessage: string;
  authorizationCode?: string;
}

export interface UserContact {
  id: number;
  uid: number;
  content: string;
  opId: number;
  opName: string;
}

export interface OpInfo {
  // opUserId: number; // 后端有返回，但是前端没有用到，先注释掉
  opPhoneNumber: number;
  opRealName: string;
}
